import { withTranslation } from "react-i18next";
import { compose } from "recompose";
import { withParentStation } from "src/modules/parent-station/ParentStation/Context";

import EveryNoise from "./EveryNoise";

const enhanced = compose(withParentStation, withTranslation());

export default enhanced(EveryNoise);
